// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
export const isLocalStorageSupported = () => {
	try {
		// use an random key to test
		const testKey = `__test_${Date.now()}__`;
		localStorage.setItem(testKey, testKey);
		localStorage.removeItem(testKey);

		return true;
	} catch (e) {
		return false;
	}
};
